import { App } from 'antd';

let _message = null;

const DURATION = 8; // seconds
const DEBOUNCE_TIME = 300; // milliseconds

// Track recent messages to prevent duplicates
const recentMessages = new Map();

/**
 * Debounced message helper - prevents duplicate messages within a time window
 */
function debouncedMessage(type, content, duration, onClose) {
  const key = `${type}:${content}`;
  const now = Date.now();
  
  // Check if this exact message was shown recently
  if (recentMessages.has(key)) {
    const lastShown = recentMessages.get(key);
    if (now - lastShown < DEBOUNCE_TIME) {
      return; // Skip duplicate
    }
  }
  
  // Show message and track it
  recentMessages.set(key, now);
  _message?.[type](content, duration, onClose);
  
  // Clean up tracking after message duration + debounce time
  setTimeout(() => {
    recentMessages.delete(key);
  }, (duration * 1000) + DEBOUNCE_TIME);
}

/** Drop-in replacement for antd static `message` calls. */
export const messageService = {
  error:   (content, duration = DURATION, onClose) => debouncedMessage('error', content, duration, onClose),
  success: (content, duration = DURATION, onClose) => debouncedMessage('success', content, duration, onClose),
  warning: (content, duration = DURATION, onClose) => debouncedMessage('warning', content, duration, onClose),
  info:    (content, duration = DURATION, onClose) => debouncedMessage('info', content, duration, onClose),
};

/** Render this once inside <AntApp> to wire up the service. */
export function MessageHolder() {
  const { message } = App.useApp();
  _message = message;
  return null;
}
